import { useTranslation } from "react-i18next";
import { NAMESPACES } from "@/i18n/constants";
import { cn } from "@/utils/class-name";
import { useFormatDuration } from "@/utils/format-duration";

interface ResponseTimeHintProps {
    responseTimeMs?: number;
    className?: string;
}

export function ResponseTimeHint({ responseTimeMs, className }: ResponseTimeHintProps) {
    const { t } = useTranslation(NAMESPACES.FEATURES.CARDS, {
        keyPrefix: "zone.on-demand-irrigation",
    });
    const formatDuration = useFormatDuration();

    if (responseTimeMs === undefined) {
        return null;
    }

    const formattedResponseTime = formatDuration(responseTimeMs, { omitZeroUnits: true });

    return (
        <p className={cn("text-xs text-muted-foreground mt-1", className)}>
            {t("response-time-hint", { duration: formattedResponseTime })}
        </p>
    );
}
